

const assetsObject = {
    totalEnergy: require('assets/total_energy.png').default,
    dailyAvg:require('assets/daily_average.png').default,
    todays:require('assets/todays.png').default,

    totalRevenue: require('assets/total_revenue.png').default,
    dailyAvg: require('assets/daily_average.png').default,
    todaysRevenue: require('assets/todays_revenue.png').default,
    lastSwappingRevenue: require('assets/last_swapping_revenue.png').default,

    totalSites: require('assets/total_sites.png').default,
    totalChargers: require('assets/total_chargers.png').default,
    totalBatteries: require('assets/total_battries.png').default,

    noidaSector: require('assets/noida_sector.png').default,

    thermometer: require('assets/thermometer.png').default,

    leaf: require('assets/leaf.png').default,
    gasPump: require('assets/gas_pump.png').default,
    
  }
 
  export default assetsObject;